// Chrome (and the ResizeObserver spec) caps how many resize-notify passes it
// runs per frame; a page with several ResizeObserver consumers reacting to
// each other's layout changes in the same tick (Monaco's own internal
// observer, the BB Config Editor's flex-based IDE shell resizing the editor
// pane on every view/panel toggle, etc.) can exceed that cap. The browser
// then throws "ResizeObserver loop completed with undelivered notifications"
// -- harmless (the spec says it just defers the rest to next frame), but
// CRA's dev error overlay treats any uncaught error as fatal and blocks the
// whole page behind a modal.
//
// The fix: defer every ResizeObserver callback to the next animation frame,
// so callbacks never fire faster than the browser can keep up with, which is
// exactly the condition that trips this over. Safe in production too, not
// just a dev-overlay workaround -- this is the standard fix for this class
// of bug (see https://github.com/WICG/resize-observer/issues/38).
export function patchResizeObserverLoopLimit() {
  if (typeof window === 'undefined' || !window.ResizeObserver) return;
  const OriginalResizeObserver = window.ResizeObserver;
  if (OriginalResizeObserver.__patchedForLoopLimit) return;

  class DebouncedResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      let rafId = null;
      super((entries, observer) => {
        if (rafId != null) window.cancelAnimationFrame(rafId);
        rafId = window.requestAnimationFrame(() => {
          rafId = null;
          callback(entries, observer);
        });
      });
    }
  }
  DebouncedResizeObserver.__patchedForLoopLimit = true;
  window.ResizeObserver = DebouncedResizeObserver;
}
